// Use production API endpoint for cdtracer
// Temporarily force production API endpoint for all environments (dev/prod)
// to route API calls to the public server https://www.cdtracer.cn
// This prevents requests from being proxied to localhost:5001 during development
// while we want to use the public remote API.
var baseUrl = 'https://www.cdtracer.cn';
export {baseUrl};